import {ActionCompareArrows, ActionDelete, ActionDone, ActionSettings, FileCloudDone} from 'material-ui/svg-icons';
import {Avatar, Chip, CircularProgress, FlatButton, MenuItem, SelectField, TextField} from 'material-ui';
import {compose, graphql} from 'react-apollo';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import styled from 'styled-components';

import {
  PublishArtCollectionMutation,
  PublishArtCollectionMutationConfig,
  PublishArtCollectionPermissionMutation,
  PublishArtCollectionPermissionMutationConfig,
  RemoveArtCollectionMutation,
  RemoveArtCollectionMutationConfig,
  RemoveArtCollectionPermissionMutation,
  RemoveArtCollectionPermissionMutationConfig,
  SaveArtCollectionMutation,
  SaveArtCollectionMutationConfig,
  SaveArtCollectionPermissionMutation,
  SaveArtCollectionPermissionMutationConfig,
  SyncArtCollectionToUserMutation,
  SyncArtCollectionToUserMutationConfig,
} from '../qql-shared/mutations';
import {TwoColContent} from './container/TwoColContent';
import DeleteModal from './DeleteModal';
import constants from '../parameters/constants';
import {withNamespaces} from 'react-i18next';
import convertErrors from '../helpers/errorHelper';

const Wrapper = styled.div`
  float: left;
  height: auto;
  width: 100%;
  border-bottom: 1px solid #efefef;
  padding: 20px ${(props) => (props.edit ? 20 : 0)}px;
  margin-top: ${(props) => (props.edit ? 30 : 0)}px;
  background: ${(props) => (props.edit ? '#efefef' : 'none')};
`;

const Name = styled.h3`
  cursor: ${({edit}) => (edit ? 'auto' : 'pointer')};
  /* color: ${constants.primaryColor}; */
  margin: 0px;
  width:40%;
`;

const FtpInfo = styled.h3`
  color: ${constants.primaryColor};
  margin: 0px;
  width: 40%;
`;
const PermissionWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

const InSyncIndicator = styled.span`
  color: ${constants.primaryColor};
  font-weight: bold;
`;

class ArtCollectionEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props.artCollection && props.artCollection.name ? props.artCollection.name : '',
      edit: false,
      remove: false,
      viewer: null,
      isSyncing: false,
      isPublishing: false,
      filesOutOfSync: props.artCollection.filesSynced ? props.artCollection.filesSynced.filesOutOfSync : -1,
    };
  }
  componentWillReceiveProps(newProps) {
    if (newProps.artCollection && newProps.artCollection.name !== this.state.name) {
      this.setState({
        name: newProps.artCollection.name,
        filesOutOfSync: newProps.artCollection.filesSynced ? newProps.artCollection.filesSynced.filesOutOfSync : -1,
      });
    }
    if (
      newProps.artCollection.filesSynced &&
      newProps.artCollection.filesSynced.filesOutOfSync !== this.state.filesOutOfSync
    ) {
      this.setState({
        filesOutOfSync: newProps.artCollection.filesSynced ? newProps.artCollection.filesSynced.filesOutOfSync : -1,
      });
    }
  }

  save = () => {
    const {setNotifications} = this.props;
    const {name} = this.state;

    if (name !== undefined && name !== '') {
      const {
        artCollection: {_id, owner},
        t,
      } = this.props;
      this.props
        .saveArtCollection({name, _id, ownerId: owner._id})
        .then(() => {
          setNotifications([t('ownCollections.collectionSaved')], []);
        })
        .catch((rawErrors) => {
          let errors = convertErrors({...rawErrors, t: t});
          setNotifications([], errors);
          console.log('there was an error sending the query', errors);
        });
      this.setState({edit: false});
    }
  };

  handleViewerChange = (event, index, value) => {
    const {
      artCollection: {_id},
      saveArtCollectionPermission,
      setNotifications,
      t,
    } = this.props;
    saveArtCollectionPermission({viewerId: value._id, artCollection: _id})
      .then(() => {
        setNotifications([t('ownCollections.permissionAdd')], []);
      })
      .catch((rawErrors) => {
        let errors = convertErrors({...rawErrors, t: t});
        setNotifications([], errors);
        console.log('there was an error sending the query', errors);
      });
  };

  handlePublishArtCollection = () => {
    const {
      artCollection: {_id, name, owner},
      publishArtCollection,
    } = this.props;
    this.publishArtCollectionChange(() => publishArtCollection(_id), name, owner.name);
  };

  handleSyncArtCollectionToUser = () => {
    const {
      artCollection: {_id, name, owner},
      syncArtCollectionToUser,
    } = this.props;
    this.syncArtCollectionToUserChange(() => syncArtCollectionToUser(_id), name, owner.name, true);
  };

  publishArtCollectionChange = (publish, artCollection, viewer) => {
    const {setNotifications, setPublishConfirmDialog, t} = this.props;
    const onConfirm = () => {
      this.setState({isPublishing: true});
      publish()
        .then(() => {
          this.setState({isPublishing: false});
          setNotifications(
            [
              `${t('ownCollections.savedSuccess')} ${t('ownCollections.collection')} ${artCollection} ${t(
                'ownCollections.can'
              )} ${viewer} ${t('ownCollections.app')}`,
            ],
            []
          );
        })
        .catch((rawErrors) => {
          let errors = convertErrors({...rawErrors, t: t});
          setNotifications([], errors);
          console.log('there was an error publishing the change', errors);
        });
    };
    setPublishConfirmDialog({onConfirm, artCollection, viewer});
  };

  syncArtCollectionToUserChange = (publish, artCollection, viewer, sync = false) => {
    const {setNotifications, setPublishConfirmDialog, t} = this.props;
    const onConfirm = () => {
      this.setState({isSyncing: true});
      this.props.startPolling(5000);
      publish()
        .then(() => {
          this.setState({isSyncing: false});
          this.props.stopPolling();
          setNotifications(
            [
              `${t('ownCollections.syncToUser')} ${t('ownCollections.collection')} ${artCollection} ${t(
                'ownCollections.nowSync'
              )}`,
            ],
            []
          );
        })
        .catch((rawErrors) => {
          let errors = convertErrors({...rawErrors, t: t});
          setNotifications([], errors);
          this.props.stopPolling();
          console.log('there was an error publishing the change', errors);
        });
    };
    const text = `${t('ownCollections.shouldCollection')} ${artCollection} ${t('ownCollections.syncronizedToUser')}`;
    setPublishConfirmDialog({onConfirm, artCollection, viewer, text});
  };

  handlePublishArtCollectionPermission = (permission) => () => {
    if (permission.published) return;
    const {
      artCollection: {name},
      publishArtCollectionPermission,
    } = this.props;
    this.publishArtCollectionChange(() => publishArtCollectionPermission(permission._id), name, permission.viewer.name);
  };

  renderItem = () => {
    const {name, edit, remove, viewer} = this.state;
    const {t} = this.props;
    const {
      addNew,
      allClients,
      removeArtCollectionPermission,
      removeArtCollection,
      artCollection: {artCollectionPermissions, name: collectionName, directoryName, _id, owner, published},
    } = this.props;

    if (!addNew) {
      return (
        <div>
          <TwoColContent>
            <Name
              edit={this.state.edit}
              onClick={() => !this.state.edit && this.setState({edit: true, name: addNew ? '' : name})}>
              {collectionName}{' '}
              {(!published || artCollectionPermissions.some(({published}) => !published)) && (
                <i>({t('ownCollections.unpublished')})</i>
              )}
            </Name>
            {directoryName && (
              <FtpInfo style={{display: 'flex'}}>
                {t('ownCollections.ftp')}: /{directoryName}
              </FtpInfo>
            )}
            <FlatButton
              style={{display: published ? 'none' : 'initial'}}
              onClick={this.handlePublishArtCollection}
              hoverColor={constants.primaryColor}
              backgroundColor={constants.primary2Color}
              icon={
                this.state.isPublishing ? (
                  <CircularProgress color={'white'} size='20' />
                ) : (
                  <FileCloudDone color={'white'} />
                )
              }
            />
            {this.state.filesOutOfSync === -1 && <div>{t('ownCollections.syncInfo')}</div>}
            {this.state.filesOutOfSync > 0 ? (
              <FlatButton
                disabled={this.state.isSyncing}
                style={{display: published ? 'initial' : 'none'}}
                onClick={this.handleSyncArtCollectionToUser}
                hoverColor={constants.primaryColor}
                backgroundColor={constants.primary2Color}
                labelStyle={{color: 'white'}}
                label={this.state.filesOutOfSync}
                labelPosition={'left'}
                icon={
                  this.state.isSyncing ? (
                    <CircularProgress color={'white'} size='20' />
                  ) : (
                    <ActionCompareArrows color={'white'} />
                  )
                }
              />
            ) : (
              <InSyncIndicator>{t('ownCollections.sync')}</InSyncIndicator>
            )}
            {edit && (
              <FlatButton
                onClick={this.save}
                disabled={!name}
                hoverColor={constants.primaryColor}
                backgroundColor={constants.primary2Color}
                icon={<ActionDone color={'white'} />}
              />
            )}

            {!edit && (
              <FlatButton
                onClick={() => {
                  this.setState({edit: true});
                }}
                hoverColor={constants.primaryColor}
                backgroundColor={constants.primary2Color}
                icon={<ActionSettings color={'white'} />}
              />
            )}
          </TwoColContent>

          {edit && (
            <div>
              <TextField
                type='text'
                fullWidth={true}
                floatingLabelText={t('ownCollections.newName')}
                value={name}
                onChange={({target: {value}}) =>
                  this.setState({
                    name: value,
                  })
                }
              />
              <SelectField
                floatingLabelText={t('ownCollections.addUser')}
                floatingLabelFixed={true}
                value={viewer}
                onChange={this.handleViewerChange}>
                {allClients
                  .filter((elem) => elem._id !== owner._id)
                  .map((viewer) => (
                    <MenuItem value={viewer} key={viewer._id} primaryText={viewer.name} />
                  ))}
              </SelectField>
              {artCollectionPermissions && artCollectionPermissions.length > 0 && (
                <PermissionWrapper>
                  {artCollectionPermissions.map((permission) => {
                    return (
                      <Chip
                        key={permission._id}
                        style={{
                          margin: 4,
                          cursor: permission.published ? 'auto' : 'pointer',
                        }}
                        onTouchTap={this.handlePublishArtCollectionPermission(permission)}
                        onRequestDelete={() => {
                          removeArtCollectionPermission(permission._id);
                        }}>
                        {!permission.published && <Avatar color='#444' icon={<FileCloudDone />} />}
                        {permission.viewer.name}
                      </Chip>
                    );
                  })}
                </PermissionWrapper>
              )}
              <div>
                <FlatButton
                  onClick={() => {
                    this.setState({remove: true});
                  }}
                  style={{float: 'right'}}
                  hoverColor={constants.primaryColor}
                  backgroundColor={constants.primary2Color}
                  icon={<ActionDelete color={'white'} />}
                />
              </div>
            </div>
          )}
          <DeleteModal
            open={remove}
            onCancel={() => {
              this.setState({remove: false});
            }}
            onConfirm={() => {
              removeArtCollection(_id).then(() => {
                this.setState({edit: false, remove: false});
              });
            }}
          />
        </div>
      );
    } else {
      return (
        <div>
          <TwoColContent>
            <Name>{t('ownCollections.newCollection')}</Name>

            <FlatButton
              onClick={this.save}
              hoverColor={constants.primaryColor}
              backgroundColor={constants.primary2Color}
              disabled={!name}
              icon={<ActionDone color={'white'} />}
            />
          </TwoColContent>
          <TextField
            type='text'
            fullWidth={true}
            floatingLabelText='Name'
            value={name ? name : ''}
            onChange={({target: {value}}) =>
              this.setState({
                name: value,
              })
            }
          />
        </div>
      );
    }
  };

  render() {
    return <Wrapper edit={this.state.edit}>{this.renderItem()}</Wrapper>;
  }
}

ArtCollectionEdit.propTypes = {
  artCollection: PropTypes.object,
  allClients: PropTypes.array,
  addNew: PropTypes.bool,
  setNotifications: PropTypes.func.isRequired,
  setPublishConfirmDialog: PropTypes.func.isRequired,
  startPolling: PropTypes.func,
  stopPolling: PropTypes.func,
};

export default withNamespaces()(
  compose(
    graphql(RemoveArtCollectionPermissionMutation, RemoveArtCollectionPermissionMutationConfig),
    graphql(RemoveArtCollectionMutation, RemoveArtCollectionMutationConfig),
    graphql(SaveArtCollectionPermissionMutation, SaveArtCollectionPermissionMutationConfig),
    graphql(SaveArtCollectionMutation, SaveArtCollectionMutationConfig),
    graphql(PublishArtCollectionMutation, PublishArtCollectionMutationConfig),
    graphql(SyncArtCollectionToUserMutation, SyncArtCollectionToUserMutationConfig),
    graphql(PublishArtCollectionPermissionMutation, PublishArtCollectionPermissionMutationConfig)
  )(ArtCollectionEdit)
);



// WEBPACK FOOTER //
// ./src/components/ArtCollectionEdit.js